import { Component, OnInit, inject } from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {XploreItemDTO} from "../../../shared/object/xplorer-be-parsed-classes";
import { XplorePageComponent } from '../../pages/xplore-page/xplore-page.component';


@Component({
    selector: 'xplorer-bowser-xplore-item-preview',
    templateUrl: './xplore-item-preview.component.html',
    styleUrls: ['./xplore-item-preview.component.css'],
    imports: [XplorePageComponent]
})
export class XploreItemPreviewComponent implements OnInit {

  xploreItemDTO: XploreItemDTO = null;

  private route: ActivatedRoute = inject(ActivatedRoute);


  ngOnInit() {
    window.addEventListener('message', (event) => {
      try {
        this.xploreItemDTO = JSON.parse(event.data);
      } catch (e) {
        return;
      }
    });
  }
}
